<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import { getApprovalTemplate } from '@/febos/servicios/api/aprobaciones.api';
import { APROBATION_USE_DISTRIBUTION } from '@/constants/settings';

export default {
  props: {
    mapper: {
      type: Function
    },
    draft: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      searchingConfig: false,
      error: {
        message: ''
      },
      rolTypesOption: [
        { id: RolTypes.APPROVER, label: 'Aprobador' },
        { id: RolTypes.REVIEWER, label: 'Revisor' },
        { id: RolTypes.SIGNER, label: 'Firmante' }
      ],
      oldFlow: {},
      step: {
        fileMime: 'application/pdf',
        fileDate: Vue.moment().format('YYYY-MM-DD HH:mm:ss'),
        oldFlow: false,
        flowId: '',
        name: '',
        file: '',
        amount: '',
        description: '',
        pdfStamp: false,
        private: false,
        setSignaturePosition: false,
        signaturesDropped: {},
        steps: [],
        attachments: [],
        references: [],
        distributions: []
      },
      rolTypes: RolTypes,
      stepTypes: StepTypes,
      stepType: StepTypes.USER,
      rolType: RolTypes.APPROVER,
      groupStep: '',
      userStep: '',
      blockButton: false
    };
  },
  watch: {
    draft(newValue) {
      this.step = {
        ...this.step,
        ...newValue
      };
    },
    'step.flowId': async function selectOldFlow(newValue) {
      if (newValue && newValue.length) {
        this.searchingFlow = false;
        this.oldFlow.pasos = [];
        const flow = this.approvalsTemplates.find((selected) => selected.id === newValue);
        if (flow) {
          this.error.message = '';
          this.step.executionType = flow.tipoEjecucion;
          this.step.objectType = flow.tipoObjeto;
        } else {
          this.error.message = '';
          this.step.executionType = '';
          this.step.objectType = '';
        }
        this.searchingFlow = true;
        const response = await this.searchApprovalTemplate(newValue);
        this.searchingFlow = false;
        this.oldFlow = response.data.aprobacion;
        console.log('EEEEEE', this.oldFlow);
        console.log('RESPONSE', response);

        this.step.steps = [];
        this.step.signaturesDropped = {};
        this.removeSignaturesDropped();
      }
    },
    'step.oldFlow': function wathStepOldFlow(newValue) {
      if (newValue) {
        if (this.thereAreSignatureStep) {
          this.step.setSignaturePosition = true;
          this.onSetSignaturePositionChange(true);
          return;
        }
        this.step.setSignaturePosition = false;
        this.onSetSignaturePositionChange(false);
      }
    }
  },
  computed: {
    ...mapGetters('Dnts', ['detailsFile']),
    ...mapGetters('Empresas', ['company', 'settings', 'settingsLoading']),
    useDistribution() {
      return this.settings[APROBATION_USE_DISTRIBUTION] === 'Y';
    },
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    thereAreSignatureStep() {
      return this.step.steps.some((step) => step.stepType === this.stepTypes.PERSON
        || step.stepType === this.stepTypes.EXTERNAL);
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'fetchCompanySetting'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    getStepData() {
      return this.step;
    },
    removeStep(stepRemove) {
      this.blockButton = false;
      this.error.message = '';
      this.step.steps = this.step.steps.filter((step) => step.stepNumber !== stepRemove.stepNumber)
        .map((stepMap, index) => ({
          ...stepMap,
          stepNumber: index + 1
        }));

      const {
        [stepRemove.responsibleId]: ignored,
        ...signaturesDropped
      } = this.step.signaturesDropped;
      this.step.signaturesDropped = signaturesDropped;

      if (!this.thereAreSignatureStep) {
        this.disableSignaturePosition = false;
      }
    },
    async searchApprovalTemplate(approvalId) {
      this.searchingFlow = true;
      this.$vs.loading({
        container: '#wizard',
        scale: 0.6
      });
      const response = await getApprovalTemplate({
        id: approvalId,
        estado: true
      });
      this.$vs.loading.close('#wizard > .con-vs-loading');
      this.searchingFlow = false;
      return response;
    },
    checkIfFlowHasSteps() {
      if (!this.step.steps.length && !this.step.oldFlow) {
        this.error.message = 'Debes agregar al menos un paso';
        throw new Error(this.error.message);
      }
    },
    checkIfLastStepsIsRevisor() {
      if (
        !this.step.oldFlow && this.step.steps.length
        && this.step.steps[this.step.steps.length - 1].rolType === RolTypes.REVIEWER
      ) {
        this.error.message = 'El último paso no puede ser revisor';
        throw new Error(this.error.message);
      }
    },
    checkIfHasSignaturePositionActiveAndSignerStep() {
      if (
        this.step.setSignaturePosition
        && !this.validIfStepsHasSigner()
      ) {
        this.error.message = 'Debes agregar al menos un paso que pueda firmar';
        throw new Error(this.error.message);
      }
    },
    checkSignatureIfFileIsAcepted() {
      const aceptedMimeTypes = [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword'
      ];

      if (
        !aceptedMimeTypes.includes(this.step.mainFile.mime)
        && this.step.steps.some((step) => (step.rolType === RolTypes.SIGNER))
      ) {
        this.error.message = 'El documento debe ser PDF, DOCX o DOC para poder firmarlo';
        throw new Error(this.error.message);
      }
    },
    validIfStepsHasSigner() {
      let hasSigner = this.step.steps.some(
        (step) => step.rolType === RolTypes.SIGNER
      );
      if (!hasSigner) {
        hasSigner = this.oldFlow?.pasos?.some(
          (step) => (+step.aprobacionesTipoRolId === RolTypes.SIGNER)
        );
      }
      if (!hasSigner) {
        return false;
      }
      return true;
    },
    adjustStepsNumbers() {
      this.step = {
        ...this.step,
        steps: this.step.steps.map((step, index) => ({
          ...step,
          stepNumber: index + 1
        }))
      };
    }
  },
  created() {
    this.fetchCompanySetting({ parameters: [APROBATION_USE_DISTRIBUTION] });
  }
};

</script>
